import(/* webpackMode: "eager" */ "/src/src/app/[variants]/(staitc-page)/terms-conditions/pc.module.scss");
;
import(/* webpackMode: "eager" */ "/src/src/app/[variants]/(staitc-page)/terms-conditions/wap.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/components/RouteMessagesProvider.tsx");
